






























import Component from 'vue-class-component'
import { Prop, Vue, Watch } from 'vue-property-decorator'
import { NotifyHelper } from 'vue-kit'
import Zone from '@/dto/Zone/Zone'
import zoneStore from '@/stores/ZoneStore'

@Component
export default class DeleteBtn extends Vue {
  @Prop(Object)
  model: Zone

  zoneStore = zoneStore
  showConfirmDialog: boolean = false
  showErrorsDialog: boolean = false
  errorText: string = ''

  deleteZone() {
    this.zoneStore
      .deleteZone(this.model)
      .catch((error: string) => {
        this.errorText = error
        this.showConfirmDialog = false
        this.showErrorsDialog = true
      })
      .catch(error => {
        NotifyHelper.error('Ошибка сервера. Обратитесь к разработчикам!')
      })
      .finally(() => {
        this.showConfirmDialog = false
      })
  }

  @Watch('showErrorsDialog')
  resetErrors(isShow: boolean) {
    if (!isShow) {
      this.errorText = ''
    }
  }
}
